import { Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ScreenRecorderService } from 'src/ScreenRecorderService';
import { SweetAlertHelper } from '../_helpers/sweet.alert.helper';
import { UploadService } from '../_services/upload.service';
import { ConstantHelper } from '../_helpers/constant.helper';

@Component({
  selector: 'app-screen-recorder',
  templateUrl: './screen-recorder.component.html',
  styleUrls: ['./screen-recorder.component.css']
})

export class ScreenRecorderComponent {
  @Input() patientName: string;
  @Input() physicianName: string;
  videoUrl: SafeUrl | undefined;
  isVideo: boolean
  selectedAction: string = 'download-upload';
  companySlug = ConstantHelper.COMPANY_SLUG;
  private combinedStream: MediaStream | undefined;
  showLoader = false;
  closeCnfFlag: boolean = false;

  constructor(
    private screenRecorderService: ScreenRecorderService,
    private sanitizer: DomSanitizer,
    public sweetAlertHelper: SweetAlertHelper,
    private UploadService: UploadService,
  ) {}

  ngOnInit(): void {
    if(!this.videoUrl){
      this.screenRecorderService.videoUrl$.subscribe(url => {
        if (url) {
          this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          this.isVideo = true
        }
      });
    }
    
    // Subscribe to loader state from service
    this.screenRecorderService.showLoader$.subscribe(showLoader => {
      this.showLoader = showLoader;
    });
  }

  startRecording(): void {
    this.screenRecorderService.startRecording(this.patientName, this.physicianName);
  }

  stopRecording(): void {
    this.screenRecorderService.stopRecording();
  }

  async closeVideoModal(){
    if(!this.closeCnfFlag){
      const alertStatus = await this.sweetAlertHelper.confirmPopUp('Please Confirm', 'Are you sure')
      if (alertStatus){
        this.isVideo = false;
        window.location.reload()
      } else {
        return false;
      }
    } else {
      this.isVideo = false;
    }
  }


  handleAction(action: any) {
    switch (action) {
      case 'download':
        this.closeCnfFlag = true;
        this.downloadVideo();
        this.closeVideoModal();
        break;
      case 'upload':
        this.closeCnfFlag = true;
        this.screenRecorderService.uploadVideoExport();
        this.closeVideoModal();
        break;
      case 'download-upload':
        this.closeCnfFlag = true;
        this.downloadVideo();
        this.screenRecorderService.uploadVideoExport()
        this.closeVideoModal();
        break;
    }
  }

  async downloadVideo() {
    this.showLoader=true;
    if (!this.videoUrl) {
      console.error('No video URL available for download.');
      return;
    }
    const url = this.videoUrl instanceof Object
      ? this.sanitizer.sanitize(SecurityContext.URL, this.videoUrl)
      : this.videoUrl;
    if (!url) {
      console.error('Sanitization failed. Invalid URL.');
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.generateFileName(this.patientName, this.physicianName)}.mp4`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.cleanupStreams();
    this.showLoader=false;
  }

  private generateFileName(patientName: string, physicianName: string): string {
    const formattedPatientName = patientName.replace(/, /g, '-');
    const formattedPhysicianName = physicianName.replace(/, /g, '-');
    const now = new Date();
    const formattedDate = `${this.pad(now.getMonth() + 1)}${this.pad(now.getDate())}${now.getFullYear()}${this.pad(now.getHours())}${this.pad(now.getMinutes())}${this.pad(now.getSeconds())}`;
    return `${formattedPatientName}_${formattedPhysicianName}_${formattedDate}`;
  }

  private pad(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }


  private cleanupStreams(): void {
    if (this.combinedStream) {
      this.combinedStream.getTracks().forEach(track => track.stop());
      this.combinedStream = undefined;
    }
  }

  async retakeHandler(){
    const alertStatus = await this.sweetAlertHelper.alertPopUp("Please click on Start to start over the screen recording")
    if (alertStatus){
      return this.isVideo = false;
    }
  }
}
